import { OrderItemType } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { WithServiceId } from '@mews-commander/types';
import { ServiceTimeUnitRebate } from '../../../components';

type AdditionalExpenses = Exclude<
    OrderItemType,
    OrderItemType.ProductOrder | OrderItemType.SpaceOrder | OrderItemType.ResourceUpgradeFee
>;

const parameterlessAdditionalExpenses = {
    [OrderItemType.AdditionalExpenseRebate]: () => (
        <LocalizedText textKey={TextKey.OrderItemTypeAdditionalExpenseRebate} />
    ),
    [OrderItemType.CancellationFee]: () => <LocalizedText textKey={TextKey.OrderItemTypeCancellationFee} />,
    [OrderItemType.CityTax]: () => <LocalizedText textKey={TextKey.OrderItemTypeCityTax} />,
    [OrderItemType.CityTaxDiscount]: () => <LocalizedText textKey={TextKey.OrderItemTypeCityTaxDiscount} />,
    [OrderItemType.CustomItem]: () => <LocalizedText textKey={TextKey.OrderItemTypeCustomItem} />,
    [OrderItemType.Deposit]: () => <LocalizedText textKey={TextKey.OrderItemTypeDeposit} />,
    [OrderItemType.ExchangeRateDifference]: () => (
        <LocalizedText textKey={TextKey.OrderItemTypeExchangeRateDifference} />
    ),

    [OrderItemType.ProductOrderRebate]: () => <LocalizedText textKey={TextKey.OrderItemTypeProductOrderRebate} />,
    [OrderItemType.ServiceCharge]: () => <LocalizedText textKey={TextKey.OrderItemTypeServiceCharge} />,
    [OrderItemType.Surcharge]: () => <LocalizedText textKey={TextKey.OrderItemTypeSurcharge} />,
    [OrderItemType.MulticurrencyFee]: () => <LocalizedText textKey={TextKey.OrderItemTypeMulticurrencyFee} />,
    [OrderItemType.TaxCorrection]: () => <LocalizedText textKey={TextKey.OrderItemTypeTaxCorrection} />,
    [OrderItemType.InvoiceFee]: () => <LocalizedText textKey={TextKey.InvoiceFee} />,
    [OrderItemType.AllowanceDiscount]: () => <LocalizedText textKey={TextKey.OrderItemTypeAllowanceDiscount} />,
    [OrderItemType.AllowanceBreakage]: () => <LocalizedText textKey={TextKey.OrderItemTypeAllowanceBreakage} />,
    [OrderItemType.AllowanceContraBreakage]: () => (
        <LocalizedText textKey={TextKey.OrderItemTypeAllowanceContraBreakage} />
    ),
};

const parameteredAdditionalExpenses = {
    [OrderItemType.NightRebate]: ({ serviceId }: WithServiceId) => <ServiceTimeUnitRebate serviceId={serviceId} />,
};

const additionalExpensesMap = {
    ...parameterlessAdditionalExpenses,
    ...parameteredAdditionalExpenses,
};

export const additionalExpensesHandler = (orderItemType: OrderItemType, args: WithServiceId): React.ReactNode => {
    if (orderItemType in additionalExpensesMap) {
        const handler = additionalExpensesMap[orderItemType as AdditionalExpenses];
        return handler(args);
    }
    return null;
};
